import type { GetMeUserResponse } from "@nlc/shared-types";

import { isTeamRole } from "@nlc/shared-types";

import { formatTimeZone } from "@/utils/formatTimezone";

const isDaylightSavingTime = () => {
  const summerTimeMonths = [10, 11, 0, 1];
  const currentMonth = new Date().getMonth();

  return summerTimeMonths.includes(currentMonth);
};

export function getTimezoneDisplayName(data: GetMeUserResponse): string {
  if (!isTeamRole(data.user.roleId)) {
    return formatTimeZone(data.user.timezone, data.user.timezoneOffset);
  }

  if (isDaylightSavingTime()) {
    return "Eastern Daylight Time (GMT-4)";
  }

  return "Eastern Time (GMT-5)";
}

export function getCurrentEasternOffset(): string {
  if (isDaylightSavingTime()) {
    return "-4:00";
  }

  return "-5:00";
}
